import { useLinkOnSameOrg } from '@monorepo/shared/hooks/navigation/useLinkOnSame/useLinkOnSameOrg';
import { useLinkOnSameProject } from '@monorepo/shared/hooks/navigation/useLinkOnSame/useLinkOnSameProject';

/** Link to the site documents top-level page (folders + parent-level files). */
export function useSiteDocumentsLink() {
  return useLinkOnSameProject('/documents');
}

/** Link to the per-folder file listing for a site. */
export function useSiteFolderDocumentsLink(folderId: string) {
  return useLinkOnSameProject(`/documents/${folderId}`);
}

/** Link to manage files for an all-sites folder in org Setup. */
export function useOrganizationDocumentFolderSetupLink(folderId: string) {
  return useLinkOnSameOrg(`/data-setup/documents/${folderId}`);
}
